// extracted by mini-css-extract-plugin
export default {"wrap":"ss-z","fullWidth":"ts-z","items":"us-z","featureCss":"vs-z","disabled":"ws-z","imgCss":"xs-z"};